export default __webpack_public_path__ + "static/media/logincart.240c8726.jpg";